var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _vm.editableFormat
        ? _c("q-slider", {
            attrs: {
              value: _vm.quality,
              min: 5,
              max: _vm.maxQuality,
              step: 1,
              "label-always": true,
              "label-value": _vm._f("formatSize")(_vm.size),
              snap: ""
            },
            on: {
              change: function(val) {
                _vm.quality = val
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          class: {
            realSize: _vm.realSize,
            "cursor-zoom-in": !_vm.realSize && !_vm.disableRealSize,
            "cursor-zoom-out": _vm.realSize && !_vm.disableRealSize
          },
          style: { maxHeight: _vm.divMaxHeight },
          attrs: { id: "cont" },
          on: { click: _vm.changeRealSize }
        },
        [
          _c("q-resize-observable", { on: { resize: _vm.onDivResize } }),
          _vm._v(" "),
          _vm.editableFormat
            ? _c("canvas", {
                class: { realSize: _vm.realSize },
                style: { maxHeight: _vm.imgMaxHeight },
                attrs: {
                  id: "canvas",
                  width: _vm.naturalWidth,
                  height: _vm.naturalHeight
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.editableFormat,
                expression: "!editableFormat"
              }
            ],
            class: { realSize: _vm.realSize },
            style: { maxHeight: _vm.imgMaxHeight },
            attrs: { id: "img", src: _vm.url },
            on: { load: _vm.init }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5485fac7", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5485fac7","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pic-resize.vue
// module id = null
// module chunks = 